import { AudioChannel } from '@app/store/reducers/audio-channels.slice';

export const UNKNOWN_CHANNEL: AudioChannel = {
  icon: 'other',
  name: 'unknown',
  settings_channels_id: 'unknown',
  channel: -1,
};
